// TestimonialCard.js
import React, { useRef } from "react";
import "./TestimonialCard.css";

export default function TestimonialCard({
  companyLogo,
  companyLogoAlt,
  quote,
  content,
  clientName,
  clientTitle,
  clientCompany,
  clientAvatar,
  clientAvatarAlt,
}) {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -10; // Max 10deg tilt
    const rotateY = ((x - centerX) / centerX) * 10;

    // Calculate shine position (0-100%)
    const shineX = (x / rect.width) * 100;
    const shineY = (y / rect.height) * 100;

    // Calculate dynamic shadow offset based on cursor position (inverted for realistic lighting)
    const shadowOffsetX = -((x - centerX) / centerX) * 6; // Max 6px offset, inverted
    const shadowOffsetY = -((y - centerY) / centerY) * 6; // Max 6px offset, inverted

    card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.005)`;

    // Update CSS custom properties for shine effect
    card.style.setProperty("--shine-x", `${shineX}%`);
    card.style.setProperty("--shine-y", `${shineY}%`);
    card.style.setProperty("--shine-opacity", "0.7");

    // Update CSS custom properties for dynamic shadows
    card.style.setProperty("--shadow-x", `${shadowOffsetX}px`);
    card.style.setProperty("--shadow-y", `${shadowOffsetY}px`);
  };

  const handleMouseEnter = () => {
    // Dispatch custom event to notify header
    window.dispatchEvent(new CustomEvent("cardHoverStart"));
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (!card) return;

    card.style.transform =
      "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
    card.style.setProperty("--shine-opacity", "0");
    card.style.setProperty("--shadow-x", "0px");
    card.style.setProperty("--shadow-y", "0px");

    // Dispatch custom event to notify header
    window.dispatchEvent(new CustomEvent("cardHoverEnd"));
  };

  return (
    <div
      className="testimonial-card"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="testimonial-card-shine"></div>
      <div className="testimonial-card-header">
        <img
          className="testimonial-company-logo"
          src={companyLogo}
          alt={companyLogoAlt || "Company Logo"}
        />
      </div>
      <blockquote className="testimonial-quote">{quote}</blockquote>
      <div className="testimonial-content">{content}</div>
      <div className="testimonial-client">
        <img
          className="testimonial-client-avatar"
          src={clientAvatar}
          alt={clientAvatarAlt || "Client Avatar"}
        />
        <div className="testimonial-client-info">
          <div className="testimonial-client-name">{clientName}</div>
          <div className="testimonial-client-title">{clientTitle}</div>
          <div className="testimonial-client-company">{clientCompany}</div>
        </div>
      </div>
    </div>
  );
}
